import * as authService from '@/data/api/auth'

export interface User {
  id: number,
  username: string,
  directory: string,
  passwordCreationDateTime: string,
  startDateTime: string,
  lastLoginDateTime: string,
  unsuccessfulLoginAttempts: number,
  micadUser: boolean,
  tradeId: number,
  forename: string,
  surname: string,
  position: string,
  organisation: string,
  telephoneNumber: string,
  telephone2Number: string,
  mobileNumber: string,
  extension: string,
  faxNumber: string,
}

export async function getUser(id: number): Promise<User | null> {
  try {
    if (!id) {
      authService.authenticate()
      return null
    }
    const r = await authService.api.get("/api/user", {params: {id}})
    if (!r) {
      return null
    }
    return r.data as User
  } catch (err) {
    console.log("getUser", err)
    return null
  }
}
